import { Box, Chip, Accordion as MuiAccordion, Paper, styled } from '@mui/material';

/**
 * A checklist row. Border, radius and shadow are the theme's, which is what the inspection
 * rows copy too, so the two lists read as one.
 *
 * What was here before fought that and lost: `border: none` never applied — the theme marks
 * its border `!important` — while a 4px radius and a flatter shadow did, so the same row
 * carried the theme's border on a surface it was not drawn for.
 */
export const Accordion = styled(MuiAccordion)({
  marginBottom: 8,
  '&:before': { display: 'none' },
  overflow: 'hidden',
});

export const ChecklistHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});

export const ChecklistInfo = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledPaper = styled(Paper)({
  display: 'flex',
  alignItems: 'center',
  width: 400,
  padding: '2px 4px',
  marginBottom: '16px',
});

export const PoiContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  cursor: 'pointer',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

interface StyledChipProps {
  backgroundColor: string;
  textColor: string;
}

export const StyledChip = styled(Chip, {

  shouldForwardProp: (prop) => prop !== 'backgroundColor' && prop !== 'textColor',
})<StyledChipProps>(({ backgroundColor, textColor }) => ({
  position: 'absolute',
  top: -8,
  right: -8,
  fontSize: '0.7rem',
  height: 20,
  backgroundColor,
  '& .MuiChip-label': {
    paddingLeft: 8,
    paddingRight: 8,
    color: textColor,
  },
}));
